import { ChainId, CurrencyAmount, ERC20Token, Pair, Token } from "@pancakeswap/sdk"
import BigNumber from "bignumber.js"
import { LP_HOLDERS_FEE, WEEKS_IN_YEAR } from "config/constants/info"
import { useAllTokens } from "hooks/Tokens"
import { useEffect, useMemo, useState } from "react"
import { useFarms, usePollFarmsWithUserData } from "state/farms/hooks"
import useSWRImmutable from "swr/immutable"
import { safeGetAddress } from "utils"
import addresses from 'config/constants/contracts'
import { fetchPositionTokens } from "views/V3Info/data/pool/poolData"
import { v3Clients, v3InfoClients } from "utils/graphql"
import { fetchAllPoolData } from "state/info/queries/pools/poolData"
import { useStableSwapPairs } from "state/swap/useStableSwapPairs"
import { getDeltaTimestamps } from "utils/getDeltaTimestamps"
import { useBlockFromTimeStampSWR } from "views/Info/hooks/useBlocksFromTimestamps"
import { SUBGRAPH_STABLE_START_BLOCK } from "views/V3Info/constants"
import { Address, formatUnits, getContract } from "viem"
import { ADDRESS_ZERO, MaxUint128, NonfungiblePositionManager, PositionMath } from "@pancakeswap/v3-sdk"
import { PositionData } from "views/V3Info/types"
import { gql } from "graphql-request"
import { usePointsFarmingContract, useV3NFTPositionManagerContract } from "hooks/useContract"
import { useSingleContractMultipleData } from "state/multicall/hooks"
import { getMulticallContract, multicallByGasLimit } from "@pancakeswap/multicall"
import { viemClients } from "utils/viem"
import { getPositionManagerContract, getV3FarmContract } from "utils/contractHelpers"
import { PoolData, usePools } from "./usePools"

const Q128 = 2n ** 128n
const API_ENDPOINT = `https://api.scan.pulsechain.com/api/v2`
const SWR_SETTINGS = {
    refreshInterval: 4000, // 5 seconds
    keepPreviousData: false,
    errorRetryCount: 3,
    errorRetryInterval: 3000,
}

export function useTokenBalances(account: string) {
    return useSWRImmutable(
        account ? [`api/tokens/balances/${account}`] : undefined,
        (ars) => {
            // console.log(`${API_ENDPOINT}/addresses/${account}/token-balances`)
            return fetch(`${API_ENDPOINT}/addresses/${account}/token-balances`).then(res => res.json())
        }, SWR_SETTINGS,
    )
}

export function useNFTBalances(account: string) {
    return useSWRImmutable(
        account ? [`api/nft/balances/${account}`] : undefined,
        () => {
            return fetch(`${API_ENDPOINT}/addresses/${account}/nft?type=ERC-721`)
                .then(async (res) => {
                    const data = await res.json()
                    return data.items.filter(item => item.token.address === addresses.nftPositionManager[ChainId.PULSE]).map(item => Number(item.id))
                })
        }, SWR_SETTINGS
    )
}

// export function useV2Positions(account: string) {
//     // const { chainId } = useActiveChainId()
//     const { data: balances, isLoading, status } = useTokenBalances(account)
//     const { data: farms, userDataLoaded: farmsLoaded } = useFarms()

//     const tokens = useAllTokens()
//     usePollFarmsWithUserData()
//     const pairBalances: { [address: string]: BigNumber } = useMemo(() => {
//         if (!isLoading && status === "success" && balances) {
//             return balances.filter(({ token }) => token.name === "🍆 9 LP").reduce((result, { token, value }) => ({ ...result, [token.address]: new BigNumber(value) }), {})
//         }
//         return {}
//     }, [balances, isLoading, status])
//     const pairSupplies: { [address: string]: BigNumber } = useMemo(() => {
//         if (!isLoading && status === "success" && balances) {
//             return balances.filter(({ token }) => token.name === "🍆 9 LP").reduce((result, { token }) => ({ ...result, [token.address]: new BigNumber(token.total_supply) }), {})
//         }
//         return {}
//     }, [balances, isLoading, status])
//     const farmingBalances: { [address: string]: BigNumber } = useMemo(() => {
//         if (!farmsLoaded)
//             return {}
//         return farms.reduce((prev, farm) => {
//             if (farm.userData && farm.userData.stakedBalance?.gt(0))
//                 return {
//                     ...prev, [farm.lpAddress]: farm.userData.stakedBalance
//                 }
//             return prev
//         }, {})
//     }, [farmsLoaded, farms])
//     const lpAddresses = useMemo(() => [...(new Set([
//         ...Object.keys(pairBalances).map(addr => addr.toLowerCase()),
//         ...Object.keys(farmingBalances).map(addr => addr.toLowerCase()),
//     ]))], [farmingBalances, pairBalances])
//     const { data: poolsData } = useSWRImmutable(
//         lpAddresses.length ? [`info/positions/v2/${account}`] : undefined,
//         () => fetchAllPoolData("PULSE", lpAddresses, false, true),
//         SWR_SETTINGS
//     )
//     const pools = useMemo(() => {
//         return lpAddresses
//             .map((address) => {
//                 return poolsData?.[address]?.data
//             })
//             .filter((pool) => pool)
//     }, [poolsData, lpAddresses])
//     return useMemo(() => {
//         if (pools) {
//             return {
//                 data: pools.map((pool) => {
//                     if (!pool.token0.address || !pool.token1.address)
//                         return undefined
//                     const token0: ERC20Token | undefined = tokens[safeGetAddress(pool.token0.address)] ?? new ERC20Token(ChainId.PULSE, safeGetAddress(pool.token0.address), 18, pool.token0.symbol, pool.token0.name)
//                     const token1: ERC20Token | undefined = tokens[safeGetAddress(pool.token1.address)] ?? new ERC20Token(ChainId.PULSE, safeGetAddress(pool.token1.address), 18, pool.token1.symbol, pool.token1.name)
//                     if (!token0 || !token1)
//                         return undefined
//                     const lpApr7d = pool.liquidityUSD > 0 ? ((pool.volumeUSDWeek + (pool.volumeOutUSDWeek ?? 0)) * LP_HOLDERS_FEE * WEEKS_IN_YEAR * 100) / pool.liquidityUSD : 0
//                     return {
//                         pair: new Pair(
//                             CurrencyAmount.fromRawAmount(token0, (new BigNumber(pool.liquidityToken0.toString()).shiftedBy(token0.decimals)).toString()),
//                             CurrencyAmount.fromRawAmount(token1, (new BigNumber(pool.liquidityToken1.toString()).shiftedBy(token1.decimals)).toString()),
//                         ),
//                         pool: {
//                             version: 'v2',
//                             address: safeGetAddress(pool.address),
//                             token0: token0.address,
//                             token1: token1.address,
//                             liquidity: Math.max(0, pool.liquidityUSD),
//                             liquidityToken0: pool.liquidityToken0,
//                             liquidityToken1: pool.liquidityToken1,
//                             volume: Math.max(0, pool.volumeUSD24H),
//                             feeTier: 0.29,
//                             fee: Math.max(0, pool.totalFees24h),
//                             apr: pool.liquidityUSD > 0 ? (Math.max(0, pool.totalFees24h) * 365 * 100) / pool.liquidityUSD : 0,
//                             lpApr7d,
//                             totalSupply: pairSupplies[safeGetAddress(pool.address)],
//                             keyword: `${token0.name} ${token0.symbol} ${token1.name} ${token1.symbol}`
//                         },
//                         balance: pairBalances[safeGetAddress(pool.address)],
//                         staked: farmingBalances[safeGetAddress(pool.address)],
//                     }
//                 }).filter(Boolean),
//                 loading: false
//             }
//         }
//         return undefined
//     }, [tokens, pools, pairBalances, pairSupplies, farmingBalances])
// }

export function useStablePositions(account: string) {
    // const { chainId } = useActiveChainId()
    const { data: balances, isLoading, status } = useTokenBalances(account)

    const tokens = useAllTokens()
    const stableSwapPairs = useStableSwapPairs()
    const pairBalances: { [address: string]: BigNumber } = useMemo(() => {
        if (!isLoading && status === "success" && balances?.length > 0) {
            return balances.filter(({ token }) => token.name === "Nineinch StableSwap LPs").reduce((result, { token, value }) => ({ ...result, [stableSwapPairs.find(pair => pair.lpAddress === token.address)?.stableSwapAddress]: new BigNumber(value) }), {})
        }
        return {}
    }, [balances, isLoading, status, stableSwapPairs])
    const pairSupplies: { [address: string]: BigNumber } = useMemo(() => {
        if (!isLoading && status === "success" && balances?.length > 0) {
            return balances.filter(({ token }) => token.name === "Nineinch StableSwap LPs").reduce((result, { token }) => ({ ...result, [stableSwapPairs.find(pair => pair.lpAddress === token.address)?.stableSwapAddress]: new BigNumber(token.total_supply) }), {})
        }
        return {}
    }, [balances, isLoading, status, stableSwapPairs])
    const [t24h, t48h, t7d, t14d] = getDeltaTimestamps()
    const { blocks } = useBlockFromTimeStampSWR([t24h, t48h, t7d, t14d])
    const lpAddresses = useMemo(() => Object.keys(pairBalances).filter(Boolean).map(addr => addr.toLowerCase()), [pairBalances])
    const { data: poolsData } = useSWRImmutable(
        lpAddresses.length ? [`info/positions/stable/${account}`] : undefined,
        () => fetchAllPoolData("PULSE", lpAddresses, blocks.map((d) => d.number >= SUBGRAPH_STABLE_START_BLOCK[ChainId.PULSE] ? d.number : SUBGRAPH_STABLE_START_BLOCK[ChainId.PULSE]), true),
        SWR_SETTINGS
    )
    const pools = useMemo(() => {
        return lpAddresses
            .map((address) => {
                return poolsData?.[address]?.data
            })
            .filter((pool) => pool)
    }, [poolsData, lpAddresses])
    return useMemo(() => {
        if (pools) {
            return {
                data: pools.map((pool) => {
                    const token0: ERC20Token | undefined = tokens[safeGetAddress(pool.token0.address)] ?? new ERC20Token(ChainId.PULSE, safeGetAddress(pool.token0.address), 18, pool.token0.symbol, pool.token0.name)
                    const token1: ERC20Token | undefined = tokens[safeGetAddress(pool.token1.address)] ?? new ERC20Token(ChainId.PULSE, safeGetAddress(pool.token1.address), 18, pool.token1.symbol, pool.token1.name)
                    // const token2: ERC20Token | undefined = tokens[safeGetAddress(pool.token2.address)] ?? new ERC20Token(ChainId.PULSE, safeGetAddress(pool.token2.address), 18, pool.token2.symbol, pool.token2.name)
                    if (!token0 || !token1)
                        return undefined
                    const lpApr7d = pool.liquidityUSD > 0 ? ((pool.volumeUSDWeek + (pool.volumeOutUSDWeek ?? 0)) * LP_HOLDERS_FEE * WEEKS_IN_YEAR * 100) / pool.liquidityUSD : 0
                    return {
                        pair: new Pair(
                            CurrencyAmount.fromRawAmount(token0, (new BigNumber(pool.liquidityToken0.toString()).shiftedBy(token0.decimals)).toString()),
                            CurrencyAmount.fromRawAmount(token1, (new BigNumber(pool.liquidityToken1.toString()).shiftedBy(token1.decimals)).toString()),
                        ),
                        pool: {
                            version: 'v2',
                            address: safeGetAddress(pool.address),
                            token0: token0.address,
                            token1: token1.address,
                            liquidity: Math.max(0, pool.liquidityUSD),
                            token0USD: pool.liquidityToken0,
                            token1USD: pool.liquidityToken1,
                            volume: Math.max(0, pool.volumeUSD24H),
                            totalSupply: pairSupplies[safeGetAddress(pool.address)],
                            feeTier: 0.29,
                            fee: Math.max(0, pool.totalFees24h),
                            apr: pool.liquidityUSD > 0 ? (Math.max(0, pool.totalFees24h) * 365 * 100) / pool.liquidityUSD : 0,
                            lpApr7d,
                            keyword: `${token0.name} ${token0.symbol} ${token1.name} ${token1.symbol}`
                        },
                        balance: pairBalances[safeGetAddress(pool.address)],
                    }
                }).filter(Boolean),
                loading: false
            }
        }
        return undefined
    }, [tokens, pools, pairBalances, pairSupplies])
}

export const POSITIONS_QUERY = (account: string) => {
    return gql`
      query {
        positions (
          where: {
            liquidity_gt: 0
            owner: "${account && account.length > 0 ? account.toLowerCase() : ""}"
          }
        ) {
          owner
          tokenId: id
          liquidity
          feeGrowthInside0LastX128
          feeGrowthInside1LastX128
          pool {
            id tick sqrtPrice feeGrowthGlobal0X128 feeGrowthGlobal1X128 token0Price token1Price totalValueLockedToken0 totalValueLockedToken1
          }
          tickLower {
            tickIdx
          }
          tickUpper {
            tickIdx
          }
          depositedToken0
          depositedToken1
          token0 {
            decimals price: derivedUSD
          }
          token1 {
            decimals price: derivedUSD
          }
        }
        stakings (
          where: {
            user: "${account && account.length > 0 ? account.toLowerCase() : ""}"
          }
        ) {
          id
          points
          blockNumber
          amountInUSD
        }
      }
    `
}

export async function fetchPositionDatas(
    account: string
) {
    try {
        const positionManager = getPositionManagerContract()
        const data = await v3Clients[ChainId.PULSE].request<any>(POSITIONS_QUERY(account))
        const feeAmounts = await Promise.all(data.positions.map(position =>
            positionManager.simulate.collect([
                {
                    tokenId: position.tokenId,
                    recipient: ADDRESS_ZERO,
                    amount0Max: MaxUint128,
                    amount1Max: MaxUint128,
                },
            ], {
                account
            }).then(results => results.result)
        ))
        const stakings = data.stakings.reduce((all, farm) => ({
            ...all,
            [String(farm.id)]: {
                points: Number(farm.points),
                amount: Number(farm.amountInUSD),
                block: farm.blockNumber ? Number(farm.blockNumber) : undefined
            }
        }), {})
        return data.positions.map((position, i) => {
            const tick = Number(position.pool.tick)
            const tickLower = Number(position.tickLower.tickIdx)
            const tickUpper = Number(position.tickUpper.tickIdx)
            const sqrtRatioX96 = BigInt(position.pool.sqrtPrice)
            const liquidity = BigInt(position.liquidity)
            const liquidityToken0 = Number(formatUnits(PositionMath.getToken0Amount(tick, tickLower, tickUpper, sqrtRatioX96, liquidity), Number(position.token0.decimals)))
            const liquidityToken1 = Number(formatUnits(PositionMath.getToken1Amount(tick, tickLower, tickUpper, sqrtRatioX96, liquidity), Number(position.token1.decimals)))
            const share = (liquidityToken0 * Number(position.pool.token1Price) + liquidityToken1) * 100 / (Number(position.pool.totalValueLockedToken0) * Number(position.pool.token1Price) + Number(position.pool.totalValueLockedToken1))
            // const share1 = (liquidityToken0 + liquidityToken1 * Number(position.pool.token0Price)) * 100 / (Number(position.pool.totalValueLockedToken0) + Number(position.pool.totalValueLockedToken1) * Number(position.pool.token0Price))
            const [fee0, fee1] = feeAmounts[i]
            const feeToken0 = Number(formatUnits(fee0, Number(position.token0.decimals)))
            const feeToken1 = Number(formatUnits(fee1, Number(position.token1.decimals)))
            // const feeToken0 = Number(formatUnits((BigInt(position.pool.feeGrowthGlobal0X128) - BigInt(position.feeGrowthInside0LastX128)) * liquidity / Q128, Number(position.token0.decimals)))
            // const feeToken1 = Number(formatUnits((BigInt(position.pool.feeGrowthGlobal1X128) - BigInt(position.feeGrowthInside1LastX128)) * liquidity / Q128, Number(position.token1.decimals)))
            const staked = stakings[String(position.tokenId)]
            return {
                owner: position.owner,
                tokenId: BigInt(position.tokenId),
                address: position.pool.id,
                liquidity,
                tick,
                tickLower,
                tickUpper,
                token0USD: Number(position.token0.price) * liquidityToken0,
                token1USD: Number(position.token1.price) * liquidityToken1,
                liquidityToken0,
                liquidityToken1,
                feeToken0,
                feeToken1,
                fee0USD: Number(position.token0.price) * feeToken0,
                fee1USD: Number(position.token1.price) * feeToken1,
                staked,
                share
            } satisfies PositionData
        })
    } catch (e) {
        console.error(e)
    }
    return {
        positions: [], pools: []
    }
}

export async function fetchPositionFees(positionManager, tokenIds?: bigint[]) {
    if (!tokenIds || tokenIds.length === 0)
        return {}
    const feeAmounts = await Promise.all(tokenIds.map(tokenId =>
        positionManager.simulate.collect([
            {
                tokenId,
                recipient: ADDRESS_ZERO,
                amount0Max: MaxUint128,
                amount1Max: MaxUint128,
            },
        ], {}).then(results => results.result)
    ))
    return feeAmounts
}

export function useV3PositionFees(tokenIds: bigint[]) {
    const positionManager = useV3NFTPositionManagerContract()

    const { data: fees, isLoading } = useSWRImmutable(
        [`info/fees/v3`, tokenIds, positionManager],
        () => fetchPositionFees(positionManager, tokenIds),
        SWR_SETTINGS
    )

    return useMemo(() => {
        return {
            data: fees ? Object.fromEntries(tokenIds.map((tokenId, index) => [String(tokenId), { fee0: fees[index][0], fee1: fees[index][1] }])) : {},
            loading: isLoading
        }
    }, [fees, isLoading, tokenIds])
}

export function useV3Positions(account: string) {
    const { data: positions, isLoading } = useSWRImmutable(
        `info/positions/v3/${account}`,
        () => fetchPositionDatas(account),
        SWR_SETTINGS
    )
    // console.log("positions", positions)

    let lpAddresses = []

    if (positions && positions.length > 0) {
        lpAddresses = [...new Set(positions.map(p => p.address))]
    }

    const { data: pools } = usePools(lpAddresses ?? [])
    return useMemo(() => {
        return {
            data: pools?.map((pool) => {
                return {
                    positions: positions && positions.length > 0 ? positions.filter(p => p.address === pool.address) : [],
                    pool,
                    // balance: pairBalances[safeGetAddress(pool.address)],
                    // staked: farmingBalances[safeGetAddress(pool.address)],
                }
            }).filter(Boolean) ?? [],
            loading: isLoading || !pools
        }
    }, [isLoading, pools, positions])
}

export function useV3Tokens(account: string, poolAddress: string, tickLower: number, tickUpper: number) {
    const { data: tokenIds, isLoading } = useSWRImmutable(
        account && poolAddress ? ['info/tokens/v3', account, poolAddress, tickLower, tickUpper] : undefined,
        () => fetchPositionTokens(v3InfoClients[ChainId.PULSE], account, poolAddress, tickLower, tickUpper),
        SWR_SETTINGS
    )
    return {
        tokenIds,
        isLoading
    }
}